import { useNavigate } from 'react-router-dom';
import CustomButton from '../reusable/CustomButton';
import BarChartIcon from '../assets/bar_chart.svg';
import { DATA_CATEGORY_LABELS, fileTypes } from '../../constants';
import useSchools from '../hooks/useSchools';

import './InsufficientData.css';

interface InsufficientDataProps {
  category: string;
  categoryId: string;
}

const dataLabelByUploadCategory: { [key: string]: string } = Object.freeze({
  [DATA_CATEGORY_LABELS[fileTypes.STUDENT_DEMOGRAPHICS]]: 'data',
  [DATA_CATEGORY_LABELS[fileTypes.STUDENT_ROSTER]]: 'roster information',
  [DATA_CATEGORY_LABELS[fileTypes.STUDENT_TRANSCRIPTS]]: 'transcript information',
  [DATA_CATEGORY_LABELS[fileTypes.TEST_SCORES]]: 'test score information',
  [DATA_CATEGORY_LABELS[fileTypes.CTE_PATHWAYS]]: 'CTE course information',
  [DATA_CATEGORY_LABELS[fileTypes.COURSE_CATALOG]]: 'course catalog information'
});

const buttonLabelByUploadCategory: { [key: string]: string } = Object.freeze({
  [DATA_CATEGORY_LABELS[fileTypes.STUDENT_DEMOGRAPHICS]]: 'demographics',
  [DATA_CATEGORY_LABELS[fileTypes.STUDENT_ROSTER]]: 'roster',
  [DATA_CATEGORY_LABELS[fileTypes.STUDENT_TRANSCRIPTS]]: 'transcripts',
  [DATA_CATEGORY_LABELS[fileTypes.TEST_SCORES]]: 'test scores',
  [DATA_CATEGORY_LABELS[fileTypes.CTE_PATHWAYS]]: 'CTE courses',
  [DATA_CATEGORY_LABELS[fileTypes.COURSE_CATALOG]]: 'course catalogs',
  'Matching': 'roster'
});

const getCategoryLabel = (categoryName: string, dataQcSchool: string) => {
  if (categoryName === 'Matching') return 'This data visualization will update as more data is uploaded.';

  let messageEnding = dataQcSchool ? 'this school' : 'all schools';

  return `To unlock this data visualization, please upload ${dataLabelByUploadCategory[categoryName]} for ${messageEnding}.`;
};

function InsufficientData({ category, categoryId }: InsufficientDataProps) {
  const navigate = useNavigate();
  const { dataQcSchool } = useSchools();

  return (
    <div className="insufficient-data-container">
      <img src={BarChartIcon} alt="bar chart icon"></img>
      <p className="bolded no-margin">More data needed</p>
      <p className="no-margin message">{getCategoryLabel(category, dataQcSchool)}</p>
      <CustomButton variant="secondary" buttonText={`Upload ${buttonLabelByUploadCategory[category]}`} buttonAction={() => navigate(`/data-upload#${categoryId}`)} />
    </div>
  );
}

export default InsufficientData;